module.exports = __webpack_public_path__ + "static/media/BusLarge.3a43dca5.png";